module.exports = __webpack_public_path__ + "img/basic_bg.d3edccba.jpeg";